import "./Profile.scss";
import { NavLink, Outlet } from "react-router-dom";

import { Typography } from "../../ui";
import { CardWhite } from "../../widgets";
import useUser from "../../data/useUser";
import { isClickruIndividual } from "../../utils/helpers";

function Profile() {
  const { user } = useUser()
  const showBankAudits = user?.is_entity && !isClickruIndividual(user);
  return (
      <div className="Profile">
        <Typography variant="h1" color="dark-gray">
          Профиль
        </Typography>
        <div className="nav">
          <NavLink to="contact-details">Общая информация</NavLink>
          {showBankAudits ? <NavLink to="bank-audits">Банковские реквизиты</NavLink> : ""}
          {/* <NavLink to="settings">Настройки</NavLink> */}
        </div>
        <CardWhite>
          <Outlet />
        </CardWhite>
      </div>
  );
}

export default Profile;
